import FormField from "./FormField";

export default class FileField extends FormField {
  constructor(minLength = 0, maxLength = 1, isOptional = false, initialValue = null, feature = undefined) {
    super(isOptional, initialValue, feature);
    this._validators = [];
  }

  defaultValue() {
      return null;
  }

  get isValid() {
      if (this._isOptional && this._value === this.defaultValue()) {
          return true;
      }
      if (!this._isOptional && (this._value === null || this._value === undefined)) {
          return false;
      }
      return this._validators.every((validator) => validator.isValid(this._value))

  }
    get hasValue() {
        const val = this._value;

        if (!val) return false;

        if (typeof val === "object") {
            return !!(val.name || val.url);
        }
        return false;
    }
}
